module.exports = __webpack_public_path__ + "static/img/307_TO8_2292_og.82216c6.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/307_TO8_2292_og.jpg
// module id = EFxp
// module chunks = 0